import { Component, Input } from '@angular/core';

@Component({
    selector: 'section-placeholder',
    templateUrl: './section-placeholder.component.html',
    styleUrls: ['../payment.component.scss']
})
export class SectionPlaceholderComponent {
    @Input('title') title;
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/payment/section-placeholder/section-placeholder.component.ts